import React from "react";
export function About() {
  return <section id="nosotros" className="scroll-mt-20 bg-paper text-ink" data-id="element-10" data-mp="flijwxuf10u9">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-24 lg:grid-cols-[1fr_1.6fr] lg:gap-20 lg:px-8 lg:py-32" data-id="element-11" data-mp="2psi9l83eeztx">
        <div data-id="element-12" data-mp="2trioifir9ibn">
          <p className="text-sm font-medium text-gold-deep" data-id="element-13" data-mp="2trr269mpcrnw">Nosotros</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-14" data-mp="2ysy9y8ouhquk">
            Protegemos y potenciamos la carrera del futbolista.
          </h2>
        </div>
        <div className="space-y-6 text-lg leading-relaxed text-ink/80" data-id="element-15" data-mp="38pt5ciptnb4m">
          <p data-id="element-16" data-mp="38o027def391d">
            <strong className="font-semibold text-ink" data-id="element-17" data-mp="3dhb9tgr1ztuc">Fortis Sports Management</strong> es una agencia de
            representación integral que protege y potencia la carrera del futbolista.
          </p>
          <p data-id="element-18" data-mp="3mi9fe3h549f1">
            Concretamos transferencias nacionales e internacionales, conseguimos oportunidades en clubes y
            asesoramos también a técnicos de fútbol. Negociamos mejores contratos, coordinamos apoyo médico y de
            bienestar, y acompañamos lo deportivo y personal con una visión de largo plazo y relaciones
            transparentes.
          </p>
          <p className="border-l-2 border-gold pl-6 text-xl font-semibold leading-snug text-ink" data-id="element-19" data-mp="2cqj255599tmw">
            Contamos con experiencia concreta y resultados comprobables.
          </p>
        </div>
      </div>
    </section>;
}